import degreeInfoReducer from "./reducers";
export { default as degreeInfoTypes } from "./types";
export { default as degreeInfoOperations } from "./operations";
export default degreeInfoReducer;
